<template>
  <div id="app" v-cloak>
    <!-- <div style="position: fixed;z-index: 100;font-size: 2vw;">{{screenWidth}}px</div> -->
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        screenWidth: document.body.clientWidth,
      }
    },
    mounted() {
      const that = this
      window.addEventListener('resize', function() {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })
      // window.onresize = () => {
      //   return (() => {
      //     window.screenWidth = document.body.clientWidth
      //     that.screenWidth = window.screenWidth
      //   })()
      // }
    },
    watch: {

    },
    methods: {

    },
  }
</script>

<style>
  /*
 #app {
 font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*/

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    overflow-y: auto;
    overflow-x: auto;
  }

  a {
    text-decoration: none;
  }

  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue